import { h, render } from 'preact';
import { forwardRef } from 'preact/compat';

const MarkerTooltip = (props) => {
    const { item, isActive, onClose } = props;

    if (!item || !item.title) {
    	return false;
    }

    return (
    	<div className="relative">
	      <div className="absolute bottom-0 left-1/2 mb-[76px] bg-white border border-darkgrey duration-300" style={{ opacity: isActive ? 100 : 0, visibility: isActive ? 'visible' : 'hidden', transitionDelay: isActive ? '200ms' : '0ms', transform: isActive ? 'translate(-50%, 0)' : 'translate(-50%, -15px)' }}>
	        { item.thumbnail &&
	        	<img className="w-[180px] lg:w-[266px] aspect-[266/190] object-cover" src={ item.thumbnail } />
	    	}

	    	{ onClose &&
	    		<button onClick={onClose} className="absolute top-[8px] lg:top-[15px] right-[8px] lg:right-[15px] bg-darkgrey/30 text-white text-[16px]/[1] lg:text-[22px]/[1] w-[28px] lg:w-[36px] h-[28px] lg:h-[36px] text-center rounded-[50px] py-1 lg:py-2"><i class="fa-thin fa-xmark"></i></button>
	    	}

	        <div className="p-[12px] lg:px-[20px] lg:py-[16px]">
	          <h3 className="text-[16px]/[18px] lg:text-[20px]/[23px] font-heldane mb-[6px] lg:mb-[18px]">{ item.title }</h3>
	          { item.link &&
		          <a className="text-blue underline font-heldane italic text-[12px] lg:text-16" target="_blank" href={ item.link }>View Project</a>
		      }
	        </div>
	    	

	        <svg className="absolute top-full left-1/2 -translate-x-1/2 -mt-[0.5px]" width="29.188" height="13" fill="none" version="1.1" viewBox="0 0 29.188 13" xmlns="http://www.w3.org/2000/svg">
	         <mask id="path-1-inside-1_103_3560" fill="#ffffff">
	          <path d="m116.91 323 14.594 13 14.594-13z" clip-rule="evenodd" fill-rule="evenodd"/>
	         </mask>
	         <g transform="translate(-116.91 -323)">
	          <path d="m117.03 323h29.067l-13.282 11.275-1.151 1.0052z" style="fill:#fff;stroke-width:0"/>
	          <path d="m116.91 323 0.665-0.747-0.284-0.253h-0.381zm14.594 13-0.665 0.747 0.665 0.592 0.665-0.592zm14.594-13v-1h-0.381l-0.284 0.253zm-29.188-1v2zm15.259 13.253-14.594-13-1.33 1.494 14.594 13zm13.264-13-14.594 13 1.33 1.494 14.594-13zm0.665-0.253v2z" fill="#202831" mask="url(#path-1-inside-1_103_3560)"/>
	         </g>
	        </svg>
        </div>
      </div>
    )
}

export default MarkerTooltip;